import { Component } from "@angular/core";

@Component({
  selector: "app-roll-payment-modal",
  templateUrl: "./roll-payment-modal.component.html",
  styleUrls: ["./roll-payment-modal.component.scss"]
})
export class RollPaymentModalComponent {}
